var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCristal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.67 128.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.5;}.cls-1,.cls-2{fill:#d7f1ff;mix-blend-mode:overlay;}.cls-3{fill:#329e51;}.cls-4{isolation:isolate;}.cls-2{opacity:.25;}.cls-5{opacity:.7;}.cls-5,.cls-6{fill:#5c7784;mix-blend-mode:multiply;}.cls-6{opacity:.45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cristaux"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.34 0 45.34 51.22 19.87 51.22 45.02 0 45.34 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "45.23 0 45.23 51.22 70.69 51.22 45.55 0 45.23 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.92,
    y: 64,
    width: 51.22,
    height: 25.61,
    transform: "translate(109.34 44.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.42,
    y: 64,
    width: 51.22,
    height: 25.61,
    transform: "translate(134.84 18.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.62,
    y: 102.39,
    width: 51.22,
    height: 25.61,
    transform: "translate(90.46 230.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.34 0 45.34 51.22 19.87 51.22 45.02 0 45.34 0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 32.42,
    y: 64,
    width: 51.22,
    height: 25.61,
    transform: "translate(134.84 18.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.92,
    y: 64,
    width: 51.22,
    height: 25.61,
    transform: "translate(109.34 44.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 19.62,
    y: 102.39,
    width: 51.22,
    height: 25.61,
    transform: "translate(90.46 230.4) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.18 33.57 78.13 68.52 60.75 62.03 90.96 33.49 91.18 33.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.1 33.54 78.05 68.49 95.43 74.98 91.32 33.62 91.1 33.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 44.22,
    y: 73.38,
    width: 37.31,
    height: 18.65,
    transform: "translate(162.35 52.74) rotate(110.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 61.62,
    y: 79.88,
    width: 37.31,
    height: 18.65,
    transform: "translate(191.92 45.21) rotate(110.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.1,
    y: 102.82,
    width: 37.31,
    height: 18.65,
    transform: "translate(80.38 238.8) rotate(-159.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.18 33.57 78.13 68.52 60.75 62.03 90.96 33.49 91.18 33.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.22,
    y: 73.38,
    width: 37.31,
    height: 18.65,
    transform: "translate(162.35 52.74) rotate(110.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 61.62,
    y: 79.88,
    width: 37.31,
    height: 18.65,
    transform: "translate(191.92 45.21) rotate(110.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 43.1,
    y: 102.82,
    width: 37.31,
    height: 18.65,
    transform: "translate(80.38 238.8) rotate(-159.53)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: ".15 59.67 12.8 84.34 .53 90.63 0 59.75 .15 59.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: ".1 59.7 12.75 84.37 25.01 78.08 .25 59.62 .1 59.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -0.92,
    y: 92.9,
    width: 27.73,
    height: 13.86,
    transform: "translate(95.88 42.77) rotate(62.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.37,
    y: 86.6,
    width: 27.73,
    height: 13.86,
    transform: "translate(96.96 28.42) rotate(62.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.68,
    y: 108.26,
    width: 27.73,
    height: 13.86,
    transform: "translate(106.48 204.68) rotate(152.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: ".15 59.67 12.8 84.34 .53 90.63 0 59.75 .15 59.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.92,
    y: 92.9,
    width: 27.73,
    height: 13.86,
    transform: "translate(95.88 42.77) rotate(62.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11.37,
    y: 86.6,
    width: 27.73,
    height: 13.86,
    transform: "translate(96.96 28.42) rotate(62.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 14.68,
    y: 108.26,
    width: 27.73,
    height: 13.86,
    transform: "translate(106.48 204.68) rotate(152.86)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.67 127.97 97.48 128.36 35.35 128.52 18.78 128.56 34.17 97 35.49 97.64 35.49 97.64 47.75 103.62 47.76 103.63 97.67 127.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.67 127.97 97.48 128.36 35.35 128.52 18.78 128.56 34.17 97 35.49 97.64 35.49 97.64 47.75 103.62 47.76 103.63 97.67 127.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.67 127.97 97.48 128.36 35.35 128.52 47.75 103.62 97.67 127.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.39 128.19 81.25 128.48 35.43 128.6 44.58 110.24 81.39 128.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "47.76 103.63 44.5 110.11 34.15 97.11 34.19 97.03 35.49 97.64 35.49 97.64 47.75 103.62 47.76 103.63"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCristal);
export default __webpack_public_path__ + "static/media/green_cristal.027d36aa3ac77da61cb9e9c2be836f78.svg";
export { ForwardRef as ReactComponent };